import type { ActivePiece, Board, Dimensions, Mino } from './types';
import { SHAPES } from './pieces';

export const COLS = 10;
export const ROWS = 18;
export const DIMENSIONS: Dimensions = { cols: COLS, rows: ROWS };

export function createBoard(cols = COLS, rows = ROWS): Board {
  return Array.from({ length: rows }, () => new Array(cols).fill(0) as Board[number]);
}

/** Absolute Feldzellen des Steins (linke-obere-Box-Ecke + lokale Minos). */
export function pieceCells(piece: ActivePiece): Mino[] {
  const shape = SHAPES[piece.type][piece.rotation];
  return shape.map(([dx, dy]) => [piece.x + dx, piece.y + dy] as Mino);
}

/**
 * Kollision: außerhalb links/rechts/unten, oder Überlappung mit gefüllter Zelle.
 * Zellen oberhalb des Feldes (y < 0) sind erlaubt (leerer Raum über dem Feld).
 */
export function collides(board: Board, piece: ActivePiece): boolean {
  const rows = board.length;
  const cols = board[0].length;
  for (const [x, y] of pieceCells(piece)) {
    if (x < 0 || x >= cols || y >= rows) return true;
    if (y >= 0 && board[y][x]) return true;
  }
  return false;
}

/** Stein fest ins Feld schreiben (mutiert eine Kopie, gibt sie zurück). */
export function lockPiece(board: Board, piece: ActivePiece): Board {
  const next = board.map((row) => [...row]) as Board;
  for (const [x, y] of pieceCells(piece)) {
    if (y >= 0 && y < next.length && x >= 0 && x < next[0].length) {
      next[y][x] = 1;
    }
  }
  return next;
}

/** Volle Zeilen entfernen, darüberliegende rutschen nach. Gibt neues Feld + Anzahl. */
export function clearLines(board: Board): { board: Board; cleared: number } {
  const cols = board[0].length;
  const kept = board.filter((row) => row.some((cell) => cell === 0));
  const cleared = board.length - kept.length;
  const empty = Array.from({ length: cleared }, () => new Array(cols).fill(0) as Board[number]);
  return { board: [...empty, ...kept], cleared };
}
